import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "../layouts/AppShell";
import { CatalogPage } from "../pages/CatalogPage";
import { CollectionPage } from "../pages/CollectionPage";
import { CollectionHistoryPage } from "../pages/CollectionHistoryPage";
import { LoginPage } from "../pages/LoginPage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { ProfilePage } from "../pages/ProfilePage";
import { ReleaseDetailPage } from "../pages/ReleaseDetailPage";
import { ProtectedRoute } from "./ProtectedRoute";
import { SessionExpiryRedirect } from "./SessionExpiryRedirect";

export function AppRoutes() {
  return (
    <>
      <SessionExpiryRedirect />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AppShell />}>
            <Route index element={<Navigate to="/catalog" replace />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route path="/collection" element={<CollectionPage />} />
            <Route path="/collection/history" element={<CollectionHistoryPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/releases/:releaseId" element={<ReleaseDetailPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/catalog" replace />} />
      </Routes>
    </>
  );
}
